export const SET_CODE_LIST = 'SET_CODE_LIST';

export const setCodeList = (codeList) => ({
    type: SET_CODE_LIST, codeList
});
